import Reveal from './Reveal';
import { timeline } from '@/mocks/home';

export default function Timeline() {
  return (
    <section id="timeline" className="py-16 md:py-24 bg-background-100 border-y border-background-200">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <Reveal>
          <div className="max-w-2xl mb-10 md:mb-14">
            <span className="text-xs tracking-[0.3em] text-accent-700 uppercase">Timeline / 走红脉络</span>
            <h2 className="mt-3 font-heading text-2xl md:text-4xl font-bold text-foreground-950">出道信息与走红快讯流</h2>
            <p className="mt-4 text-sm md:text-base text-foreground-600 leading-relaxed">
              按时间顺序排列的关键节点，帮助你把零散的信息串成一条清晰的时间线。
            </p>
          </div>
        </Reveal>

        <div className="relative pl-6 md:pl-10 border-l border-background-300">
          {timeline.map((node, idx) => (
            <Reveal key={node.time} delay={idx * 70}>
              <div className="relative pb-8 last:pb-0">
                <span className="absolute -left-[31px] md:-left-[47px] top-1.5 w-4 h-4 rounded-full bg-accent-500 ring-4 ring-background-100"></span>
                <div className="flex flex-col sm:flex-row sm:items-baseline gap-1 sm:gap-4 mb-2">
                  <span className="font-heading text-sm font-bold text-accent-700 sm:w-32 shrink-0">{node.time}</span>
                  <h3 className="font-heading text-lg font-semibold text-foreground-950">{node.title}</h3>
                </div>
                <p className="text-sm text-foreground-600 leading-relaxed sm:pl-36">{node.text}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}